import Selector from "@/v2-backoffice-client/components/selector"
import type { UserFragment } from "@/v2-backoffice-client/user/__types__/user.fragment"
import { formatUserName } from "@/v2-backoffice-client/user/user.utils"
import UserCustomerUpdateSelectorList from "@/v2-backoffice-client/user/customer/update/UserCustomerUpdateSelectorList"

export type UserCustomerUpdateSelectorDialogProps = {
  open: boolean
  onOpenChange(open: boolean): void
  user: UserFragment
}

function UserCustomerUpdateSelectorDialog(
  props: UserCustomerUpdateSelectorDialogProps,
) {
  const { open, onOpenChange, user } = props

  return (
    <Selector.Dialog
      open={open}
      onOpenChange={onOpenChange}
      title={`Update Customer for ${formatUserName(user.FirstName, user.LastName)}`}
      description="The customer that owns the user: whose licenses and seats apply to them. The customers of the user's teams are listed first; search for any other."
    >
      <UserCustomerUpdateSelectorList user={user} open={open} />
    </Selector.Dialog>
  )
}

export default UserCustomerUpdateSelectorDialog
